import { loadDataFromCsv } from '@/utils/csvUtils'

export const loadAllJobs = async (): Promise<any> => {
  return await loadDataFromCsv('/data/job_roles.csv')
}

export const loadAllTech = async (): Promise<any> => {
  return await loadDataFromCsv('/data/programming_languages.csv')
}
